export class Farmaco {
    ID_MEDICA: string;
    NOM: string;
    TIPO_TRATAMIENTO: string;
    DURACION_TRATAMIENTO: string;
    FECHA_INICIO_TRATAMIENTO: string;
    FECHA_FIN_TRATAMIENTO: string;
    NUM_EXPEDIENTE: string;
    DOSIS: string;
    ULTPLANTTO: string;
    NOMCEN: string;
    FECHA_PROX_ENTREGA: string;
}



// WEBPACK FOOTER //
// ./src/models/farmaco.ts